module.exports = __webpack_public_path__ + "static/media/515OliverStNW_2018-07-09_202.bc601330.jpg";